export const ICON_NAME = {
  lentaLogo: 'lenta-logo',
  lentaText: 'lenta-text',
  priceText: 'price-text',
  sidebarClose: 'sidebar-close',
  sidebarOpen: 'sidebar-open',
  catalog: 'catalog',
  catalogMonitoring: 'catalog-monitoring',
  plus: 'plus',
  report: 'report',
  resultMonitoring: 'result-monitoring',
  contractorSection: 'contractor-section',
  startMonitoring: 'start-monitoring',
  arrowDown: 'arrow-down',
  arrowUp: 'arrow-up',
  arrowBack: 'arrow-back',
  resetSearch: 'reset-search',
  search: 'search',
  setting: 'setting',
  close: 'close',
  notification: 'notification',
  logout: 'logout',
  confirmedByLenta: 'confirmed-by-lenta',
  edit: 'edit',
  delete: 'delete',
  draggable: 'draggable',
  group: 'group',
  broadcasting: 'broadcasting',
  priceChange: 'price-change',
  priceTag: 'price-tag',
  weight: 'weight',
  transferResults: 'transfer-results',
  warningYellow: 'warning-yellow'
} as const
